import { createDynamicQueryResource } from '@subtile/project-shared';
import type { Accessor } from 'solid-js';
import document, { type ExpensesVars } from '../queries/expensesQuery';
import type { Expenses } from '../types';

export default (variables: Accessor<ExpensesVars | null>) =>
  createDynamicQueryResource<Expenses, ExpensesVars>(document, variables);
